exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ft11[data-v-e7d9db18] {\n    font-size: 11px;\n}\n.shop_code[data-v-e7d9db18] {\n    width: 175px;\n    margin: 42% auto 0;\n}\n", ""]);

// exports
